<template>
    <prime-dialog
        :closable="props.closable"
        :draggable="false"
        :style="{ width: '50vw' }"
        class="generic-dialog"
        dismissable-mask
        header="Enact Terms of Use"
        modal
        :visible="props.visible"
    >
        <enact-terms-content />
        <template #footer>
            <prime-button label="Accept" @click="emit('accept')" />
            <prime-button class="plain-btn" label="Decline" @click="emit('decline')" />
        </template>
    </prime-dialog>
</template>

<script setup lang="ts">
import PrimeDialog from 'primevue/dialog';
import PrimeButton from 'primevue/button';
import EnactTermsContent from '@/components/powerMarkets/EnactTermsContent.vue';

const props = defineProps<{
    closable?: boolean;
    visible: boolean;
}>();

const emit = defineEmits<{
    accept: [];
    decline: [];
}>();
</script>
